import dayjs from 'dayjs';
import { Logger } from 'types';
import { SkuDetails } from '../analytics/types';

// Add to this constant to set stores that are microSites of DSG. This is used to pass the channel param to the product API
export const micrositeStores = ['g3'];

export function getCookie(cname: string) {
  const name = `${cname}=`;
  if (typeof document !== 'undefined') {
    const cookies = document.cookie.split(';');

    const foundCookie = cookies.find((cookie) => cookie.trimStart().startsWith(name));
    return foundCookie ? foundCookie.trimStart().substring(name.length) : '';
  }
  return '';
}

export const calculateAddToCartPrice = (skuPrice: number, cartCount: number) => {
  return (skuPrice * cartCount).toFixed(2);
};

export const checkIfPreOrderSKU = (sku: SkuDetails, log?: Logger['warn']) => {
  return sku?.descriptiveAttributes?.find((attribute) => {
    if (attribute.name === 'PRESALE_END_DATE') {
      try {
        const preOrderEndDate = dayjs(attribute.value, 'MM-DD-YYYY');
        const nextDay = dayjs().add(1, 'day');

        // If pre sale end date is in the future
        if (nextDay.diff(preOrderEndDate) < 0) {
          return true;
        }
        return false;
      } catch (error) {
        if (log) {
          log(error);
        }
        return false;
      }
    }

    return false;
  });
};

export const checkComingSoonEndDate = (comingSoonEndDate: string) => {
  const now = dayjs();
  const comingSoon = dayjs(comingSoonEndDate, 'MM-DD-YYYY');
  if (now.diff(comingSoon) < 0) {
    return true;
  }
  return false;
};
